
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 11","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.875 2.688A9.68 9.68 0 007 2.824c.11.192.191.547.219.739 0 .847-.711 1.53-1.532 1.53-.218 0-.574-.081-.738-.19a3.05 3.05 0 00-.136.847 3.057 3.057 0 003.062 3.063 3.057 3.057 0 003.063-3.063 3.075 3.075 0 00-3.063-3.063zm7.766 2.68C14.164 2.467 11.21.5 7.875.5 4.512.5 1.559 2.469.082 5.367a.999.999 0 000 .793C1.559 9.06 4.512 11 7.875 11c3.336 0 6.29-1.941 7.766-4.84a.999.999 0 000-.793zm-7.766 4.32c-2.707 0-5.195-1.504-6.508-3.938C2.68 3.316 5.168 1.812 7.875 1.812c2.68 0 5.168 1.504 6.48 3.938-1.312 2.434-3.8 3.938-6.48 3.938z"}})])
          )
        }
      }
    